<app-admin-page-model routeName="Archives" pageTitle="Archives des informations publiées">
  @if(!infos) {
    <div class="pt-5">
      <ls-spinner/>
    </div>
  } @else if ((infos | infotype:'ARCHIVED').length > 0) {
    <div class="position-relative">
      <button class="btn btn-danger position-absolute purge-position" (click)="this.toPurge = encodedInfos">Purger les archives
      </button>
    </div>
    <app-search-bar (search)="search = $event" [resultsCount]="(infos | infotype:'ARCHIVED' | search:search).length"></app-search-bar>

    @for (info of infos | infotype:'ARCHIVED' | search:search; track info) {
      <app-info-block [info]="info"></app-info-block>
    } @empty {
      <p class="text-light-grey">Aucun résultat</p>
    }
  } @else {
    <p class="text-light-grey">Aucune archive à afficher</p>
  }

  <app-dynamic-modal-form
    title="Purge des archives"
    [object]="toPurge"
    [actions]="[{label: 'Purger les archives', class: 'btn-danger', icon: 'trash-alt'}]"
    (onSubmit)="purgeArchives()"
    (onCancel)="toPurge = undefined">
    <ng-template>
      <div class="col-12">
        <p class="alert alert-danger">Veuillez extraire les archives avant de les purger</p>
        <a target="_blank" download="extraction-archives.json" [href]="encodedInfos" class="btn btn-outline-primary">
          <fa-icon icon="download" size="lg"></fa-icon>
          Extraire au format JSON</a>
      </div>
    </ng-template>
  </app-dynamic-modal-form>

</app-admin-page-model>
